import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'displayLinks'
})
export class DisplayLinksPipe implements PipeTransform {

  transform(links: any, args?: any): any {
    return links.filter((link) => {
      let timezone = args;
      let start = timezone && link.startTime ? moment(link.startTime, timezone) : link.startTime;
      let end = timezone && link.endTime ? moment(link.endTime, timezone) : link.endTime;
      let isInTime = true;
      if (start) {
        isInTime = moment().isAfter(link.startTime);
      }
      if (end && isInTime) {
        isInTime = moment().isBefore(link.endTime);
      }
      return link && link.active && isInTime;
    });
  }

}



// WEBPACK FOOTER //
// ./src/pipes/display-links.pipe.ts